import { defineMessages } from 'react-intl';

const messages = defineMessages({
  description: {
    id: 'modules.RedeemCoupon.description',
    defaultMessage:
      'Have you received a giftcard with a voucher code? It can be redeemed for a subscription.'
  },
  valueCodeLabel: {
    id: 'modules.RedeemCoupon.valueCodeLabel',
    defaultMessage: 'Six-character voucher code'
  }
});

export default messages;
